/* TEMPL — autoplay videos, no controls
   Pairs with templ-video-no-controls.css. Loaded only on the Genesis and
   Salt & Lyte product templates.

   The CSS hides the native control chrome in Chrome and Safari, but Firefox
   ignores the ::-webkit-media-controls pseudo-elements, so the `controls`
   attribute has to come off the element itself. This also locks the video
   muted and blocks download / fullscreen / picture-in-picture / AirPlay, so
   there is no route back to a player UI through a context menu either.

   The script tag is NOT deferred on purpose: it runs as the head parses and
   the observer picks up each <video> as it appears, including any that
   <deferred-media> swaps in from its <template> later.

   Deliberately NOT done: forcing playback to resume on pause. Nothing the
   visitor can do will pause these, so a pause here means the browser did it —
   tab hidden, battery saver, reduced motion — and fighting that wastes their
   battery. */

(function () {
  'use strict';

  var SELECTOR = 'deferred-media[autoplay] video';

  function lock(video) {
    if (!video || video.dataset.templNoControls === '1') return;
    video.dataset.templNoControls = '1';

    video.controls = false;
    video.removeAttribute('controls');

    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');

    video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
    video.setAttribute('disableremoteplayback', '');
    try { video.disablePictureInPicture = true; } catch (err) {}
    video.setAttribute('disablepictureinpicture', '');

    // Belt and braces: the right-click menu can still offer "Show controls".
    video.addEventListener('contextmenu', function (e) { e.preventDefault(); });
  }

  function sweep(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var found = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < found.length; i++) lock(found[i]);
  }

  sweep();

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (!node || node.nodeType !== 1) continue;
        if (node.tagName === 'VIDEO') {
          if (node.closest && node.closest('deferred-media[autoplay]')) lock(node);
        } else {
          sweep(node);
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () { sweep(); });
})();